import { MessageChannel } from '../assistant';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_MESSAGE_CHANNEL = 'MESSAGE_CHANNEL_';

export const MessageChannelTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_MESSAGE_CHANNEL}${MessageChannel.WEB}`]: 'Web',
    [`${TRANSLATE_KEY_MESSAGE_CHANNEL}${MessageChannel.WEB_WIDGET}`]: 'Widget web',
    [`${TRANSLATE_KEY_MESSAGE_CHANNEL}${MessageChannel.WHATSAPP}`]: 'WhatsApp',
    [`${TRANSLATE_KEY_MESSAGE_CHANNEL}${MessageChannel.MESSENGER}`]: 'Messenger',
    [`${TRANSLATE_KEY_MESSAGE_CHANNEL}${MessageChannel.INSTAGRAM}`]: 'Instagram',
    [`${TRANSLATE_KEY_MESSAGE_CHANNEL}${MessageChannel.EMAIL}`]: 'Email',
    [`${TRANSLATE_KEY_MESSAGE_CHANNEL}${MessageChannel.SYSTEM}`]: 'Système',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(MessageChannel, MessageChannelTranslation, TRANSLATE_KEY_MESSAGE_CHANNEL, true);
